<template>
    <div class="row justify-content--center" v-show="user_id != user.id">
        <div class="col-6" v-if="status == 'can_be_friend'">
            <a class="btn btn--block btn--sm btn--secondary btn--left-icon" @click="createFriendRequest">
                <svg class="icon"><use xlink:href="/img/icon-sprite.svg#user"></use></svg>
                Add Friend
            </a>
        </div>

        <div class="col-6" v-if="status == 'pending'">
            <a class="btn btn--block btn--sm btn--secondary btn--left-icon" @click="acceptFriendRequest">
                <svg class="icon"><use xlink:href="/img/icon-sprite.svg#user"></use></svg>
                Accept Friend Request
            </a>
        </div>
        <div class="col-6" v-if="status == 'pending'">
            <a class="btn btn--block btn--sm btn--primary btn--left-icon" @click="denyFriendRequest">
                <svg class="icon"><use xlink:href="/img/icon-sprite.svg#user"></use></svg>
                Deny Friend Request
            </a>
        </div>

        <div class="col-6" v-if="status == 'friends'">
            <button @click="sendMessage(user_id)" class="btn btn--block btn--sm btn--secondary btn--left-icon">
                <svg class="icon"><use xlink:href="/img/icon-sprite.svg#bubble"></use></svg>
                Send message
            </button>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import api from "../../api/friendship";
import chatApi from "../../api/chat";

export default {
    props: [
        'user_id'
    ],

    data() {
        return {
            status: 'can_be_friend',
        }
    },

    computed: {
        ...mapGetters('auth', [
            'user',
        ]),
    },

    methods: {
        async relationshipStatus() {
            try {
                let response = await api.checkStatus(this.user_id);

                this.status = response.data;
            } catch (error) {

            }
        },

        async createFriendRequest() {
            try {
                await api.createFriendRequest(this.user_id)

                this.relationshipStatus()
            } catch (error) {

            }
        },

        async acceptFriendRequest() {
            try {
                await api.acceptFriendRequest(this.user_id)

                this.relationshipStatus()
            } catch (error) {
            }
        },

        async denyFriendRequest() {
            try {
                await api.denyFriendRequest(this.user_id)

                this.relationshipStatus()
            } catch (error) {
            }
        },

        sendMessage(userId) {
            chatApi.createChat(this.user.id, userId).then((response) => {
                this.$router.push('/chat/' + response.data.data.id)
            })
        },
    },

    mounted() {
        this.relationshipStatus()
    }
}
</script>